import React, { useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { pageSamples } from '../data/content';
export function InsidePages() {
  const trackRef = useRef<HTMLDivElement>(null);
  const [index, setIndex] = useState<number>(0);
  const total = pageSamples.length;
  const goTo = (next: number) => {
    const track = trackRef.current;
    if (!track) return;
    const clamped = Math.max(0, Math.min(total - 1, next));
    track.scrollTo({
      left: clamped * track.clientWidth,
      behavior: 'smooth'
    });
    setIndex(clamped);
  };
  const handleScroll = () => {
    const track = trackRef.current;
    if (!track || track.clientWidth === 0) return;
    const current = Math.round(track.scrollLeft / track.clientWidth);
    if (current !== index) setIndex(current);
  };
  return <section id="inside-pages" className="w-full bg-cream px-5 py-20 sm:py-28" data-id="element-152" data-mp="3pmeu5g2ssjhh">
      <div className="mx-auto max-w-5xl" data-id="element-153" data-mp="3kvq3g2yxzqje">
        <div className="mx-auto max-w-2xl text-center" data-id="element-154" data-mp="3kuogp18kdflu">
          <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand" data-id="element-155" data-mp="1mmmdnghh7ttw">
            Blättere durch das Material
          </span>
          <h2 className="mt-5 font-display text-[1.8rem] font-black leading-tight tracking-tight text-ink sm:text-[2.6rem]" data-id="element-156" data-mp="1rkxmpozy60b2">
            Sieh dir die Seiten <span className="italic text-brand" data-id="element-157" data-mp="1hve2og0i00em">von innen an.</span>
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-ink/60 sm:text-base" data-id="element-158" data-mp="1ht9o944z3j03">
            Echte Seiten aus dem Paket – von den ersten Grundlagen bis zu Algebra, Geometrie,
            Statistik und Problemlösen.
          </p>
        </div>

        <div ref={trackRef} onScroll={handleScroll} role="group" aria-roledescription="Karussell" aria-label="Beispielseiten aus dem Material" tabIndex={0} onKeyDown={event => {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          goTo(index + 1);
        }
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goTo(index - 1);
        }
      }} className="no-scrollbar mt-10 flex w-full snap-x snap-mandatory overflow-x-auto overscroll-x-contain rounded-3xl focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/30" data-id="element-159" data-mp="uvyf8c76t2jx">
          {pageSamples.map((page, pageIndex) => <article key={page.src} aria-roledescription="Folie" aria-label={`${pageIndex + 1} von ${total}`} className="w-full min-w-0 shrink-0 snap-start" data-id="element-160" data-mp="osto7m4rc2n9" data-mpi={pageIndex}>
              <div className="grid gap-6 md:grid-cols-2 md:items-center md:gap-8" data-id="element-161" data-mp="fzq4wx7fkvkp">
                <div className="relative min-w-0 overflow-hidden rounded-3xl bg-white p-3 shadow-soft sm:p-4" data-id="element-162" data-mp="b1yds5em1dhk">
                  <img src={page.src} alt={`${page.title} — Beispielseite, ${page.level}`} loading={pageIndex === 0 ? 'eager' : 'lazy'} className="block h-auto w-full rounded-xl" data-id="element-163" data-mp="18h2h5ye4kcnt" />
                  <button type="button" onClick={() => goTo(pageIndex - 1)} aria-label="Vorherige Seite" className="absolute left-3 top-1/2 z-10 inline-flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full bg-ink/90 text-white shadow-soft transition-[transform,background-color] duration-150 ease-out hover:scale-105 hover:bg-brand focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/30" data-id="element-164" data-mp="1g03d9ymlj415">
                    <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-165" data-mp="23pnyypa4wfe4" />
                  </button>
                  <button type="button" onClick={() => goTo(pageIndex + 1)} aria-label="Nächste Seite" className="absolute right-3 top-1/2 z-10 inline-flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full bg-ink/90 text-white shadow-soft transition-[transform,background-color] duration-150 ease-out hover:scale-105 hover:bg-brand focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/30" data-id="element-166" data-mp="28nz7mwop0jur">
                    <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-167" data-mp="2ds9tywfmoo7i" />
                  </button>
                  <span aria-hidden="true" className="pointer-events-none absolute bottom-3 left-1/2 -translate-x-1/2 rounded-full bg-ink/85 px-3.5 py-1.5 text-[10px] font-bold uppercase tracking-[0.14em] text-white" data-id="element-168" data-mp="28u88k4uqccsv">
                    {pageIndex + 1} / {total}
                  </span>
                </div>

                <div className="min-w-0 md:pr-4" data-id="element-169" data-mp="1q25qcp2fwogi">
                  <p className="text-[10px] font-bold uppercase tracking-[0.16em] text-brand" data-id="element-170" data-mp="1q5juo2unz7ql">
                    {page.level}
                  </p>
                  <h3 className="mt-2 font-display text-xl font-bold leading-snug text-ink sm:text-2xl" data-id="element-171" data-mp="31havs0tyh13t">
                    {page.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-ink/60" data-id="element-172" data-mp="s9o9r8y0wv7u">{page.caption}</p>
                </div>
              </div>
            </article>)}
        </div>

        <p className="mt-3 text-center text-xs font-bold tabular-nums text-ink/40" data-id="element-173" data-mp="ebzpa27vbq3b">
          {index + 1} / {total}
        </p>
      </div>
    </section>;
}